import React from 'react';
import { Mail, MapPin, Lock, Database, Search, BarChart3 } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const services = [
    { icon: Lock, title: 'Private LLM Hosting', path: '/services/sovereign-ai' },
    { icon: Search, title: 'Precision RAG', path: '/services/precision-rag' },
    { icon: Database, title: 'AI Data Lakes', path: '/services/semantic-lakehouse' },
    { icon: BarChart3, title: 'Agentic Dashboards', path: '/services/agentic-dashboard' },
  ];

  return (
    <footer id="contact" className="bg-white border-t border-gray-200">
      <div className="container mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand column */}
          <div className="lg:col-span-1">
            <div className="flex items-center mb-5">
              <img
                src="/beemind-logo.svg"
                alt="BeeMind AI Logo"
                className="h-9 object-contain"
              />
            </div>
            <p className="text-gray-500 text-sm leading-relaxed">
              Sovereign AI infrastructure for global finance. Private Cloud LLM Orchestration,
              Precision RAG, and AI-Native Data Lakes — turning complex financial data into
              audit-ready intelligence.
            </p>
          </div>

          {/* Solutions column */}
          <div>
            <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-5">Solutions</h3>
            <ul className="space-y-3">
              {services.map((service) => {
                const Icon = service.icon;
                return (
                  <li key={service.path}>
                    <Link
                      to={service.path}
                      className="flex items-center space-x-2.5 text-sm text-gray-500 hover:text-orange-500 transition-colors"
                    >
                      <Icon className="w-4 h-4" />
                      <span>{service.title}</span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Company column */}
          <div>
            <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-5">Company</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm text-gray-500 hover:text-orange-500 transition-colors">About Us</Link>
              </li>
              <li>
                <Link to="/#contact" className="text-sm text-gray-500 hover:text-orange-500 transition-colors">Contact</Link>
              </li>
              <li>
                <Link to="/careers" className="text-sm text-gray-500 hover:text-orange-500 transition-colors">Careers</Link>
              </li>
              <li>
                <Link to="/#privacy" className="text-sm text-gray-500 hover:text-orange-500 transition-colors">Privacy Policy</Link>
              </li>
            </ul>
          </div>

          {/* Contact column */}
          <div>
            <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-5">Contact</h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <MapPin className="w-4 h-4 text-orange-500 mt-0.5 flex-shrink-0" />
                <div className="text-sm">
                  <p className="font-medium text-gray-800">BeeMind AI Private Limited</p>
                  <p className="text-gray-500">52, Gokarn, Car Street</p>
                  <p className="text-gray-500">Gokarn, Karnataka, India 581326</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-4 h-4 text-orange-500 flex-shrink-0" />
                <a href="mailto:info@beemind.ai" className="text-sm text-gray-500 hover:text-orange-500 transition-colors">
                  info@beemind.ai
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-xs">
              &copy; {new Date().getFullYear()} BeeMind AI Private Limited. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
